var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNormalTrapezoid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 108,
    viewBox: "0 0 120 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1313_2373",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 108
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M12 0H108L120 108H0L12 0Z",
    fill: "url(#paint0_linear_1313_2373)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1313_2373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    d: "M12 0H108L120 108H0L12 0Z",
    fill: "#92C34D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1313_2373",
    x1: 1.33157,
    y1: -2.62507,
    x2: 1.33157,
    y2: 114.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABACAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8A89"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalTrapezoid);
export default __webpack_public_path__ + "static/media/normal-trapezoid.b0c91f08.svg";
export { ForwardRef as ReactComponent };